function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

if(window.innerWidth > 768) {
  document.querySelectorAll('[id^="Details-"]').forEach((details) => {
    const summary = details.querySelector('summary');
  
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", details.hasAttribute("open"));
  
    if (summary.nextElementSibling?.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    if(details.closest('.list-menu')) {
      let closeTimeout;
  
      details.addEventListener("mouseenter", () => {
        clearTimeout(closeTimeout);
        details.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
      });
    
      details.addEventListener("mouseleave", () => {
        closeTimeout = setTimeout(() => {
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        }, 200);
      });
    } else {
      summary.addEventListener("click", (event) => {
        event.currentTarget.setAttribute(
          "aria-expanded",
          !event.currentTarget.closest("details").hasAttribute("open")
        );
      });
    }

    if (summary.closest("header-drawer, menu-drawer")) return;
  });
} else {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );
  
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
  
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
  
    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function  setViewportHeight() {
  let vh = window.innerHeight  *  0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();
window.addEventListener('resize', setViewportHeight);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");

    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });

    document.body.classList.remove(`overflow-hidden-mobile`);
    document.body.classList.remove(`overflow-hidden-tablet`);
    document.body.classList.remove(`overflow-hidden-desktop`);
    
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    // removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);

    document.body.classList.remove(`overflow-hidden-mobile`)
    document.body.classList.remove(`overflow-hidden-tablet`)
    document.body.classList.remove(`overflow-hidden-desktop`)
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    // removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector(".announcement-bar-slider")) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia("(min-width: 750px)");
      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => {
          if (this.slider.getAttribute("data-autoplay") === "true")
            this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector(".announcement-bar-slider").contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    this.updatePriceButton()
  }
  updatePriceButton(){
    let priceNeedUpdate = document.getElementById("rocket-price-update");
    let statusQuantityNeedUpdate = document.getElementById("rocket-status-quantity-update");
    let priceContainer = document.querySelector(".rocket-buy-now__price")
    const stickyBuyBtn = document.querySelector(".product-form.rocket-buy-buttons-mobile")
    const stickyContainerButton = document.querySelector(".sticky-button--add-to-cart__container")
    const stickyButton = document.querySelector(".btn-sticky-add-to-cart")
    const variantInput = document.getElementById("quantity-stock_inventory")
    if(variantInput){
      variantInput.value = this.currentVariant.id
      variantInput.setAttribute("data-value", this.currentVariant.id);
    }
    const variantInputMb = document.querySelector(".product-variant-id.sticky-mobile")
    if(variantInputMb){
      variantInputMb.value = this.currentVariant.id
    }
    if(priceContainer){
      priceContainer.style.display = this.currentVariant.available ? 'flex' : 'none'
    }
    if(priceNeedUpdate){
      priceNeedUpdate.innerHTML = Shopify.formatMoney(this.currentVariant.price)
    }
    const stickyElement = document.getElementById('selected-status');
    if (stickyElement) {
      const inStockText = statusQuantityNeedUpdate.getAttribute("data-in-stock");
      const outOfStockText = statusQuantityNeedUpdate.getAttribute("data-out-of-stock");
      stickyElement.innerHTML = this.currentVariant.available ? inStockText : outOfStockText
      let priceNeedUpdateSticky = document.getElementById("selected-price") ;
      if(priceNeedUpdateSticky){
        priceNeedUpdateSticky.innerHTML = this.currentVariant.available ?  Shopify.formatMoney(this.currentVariant.price) : ""
      }
    }
    if(statusQuantityNeedUpdate){
      const inStockText = statusQuantityNeedUpdate.getAttribute("data-in-stock");
      const outOfStockText = statusQuantityNeedUpdate.getAttribute("data-out-of-stock");
      statusQuantityNeedUpdate.innerHTML = this.currentVariant.available ? inStockText : outOfStockText
    }
    let rocketBuyNow = document.querySelector("rocket-buy-now");
    if (rocketBuyNow) {
      rocketBuyNow.setAttribute("data-available", this.currentVariant.available);
    }
    if(stickyButton){
      if(this.currentVariant.available){
        stickyButton.classList.remove('soldout')
      } else {
        stickyButton.classList.add('soldout')
      }
    }
    if(stickyContainerButton){
      if(this.currentVariant.available){
        stickyContainerButton.classList.remove('sticky-agotado')
      } else {
        stickyContainerButton.classList.add('sticky-agotado')
      }
    }
    if(stickyBuyBtn){
      const stickyOptions = stickyBuyBtn.querySelectorAll(".sticky-size-options .sticky-option");
      stickyOptions.forEach((stickyOption) => {
        const stickyOptionColor = stickyOption.getAttribute("color_id");
        if (this.currentVariant.option2) {
          if (stickyOptionColor.toLowerCase() === (this.currentVariant.option2).toLowerCase()) {
            stickyOption.classList.remove("hidden");
          }
          else {
            stickyOption.classList.add("hidden");
          }
        }
      });
    }
    const sizeTriggerButton = document.querySelector(".sticky-select__trigger.button-primary");
    if (sizeTriggerButton) {
        sizeTriggerButton.textContent = this.currentVariant.title;
    }
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        `${this.currentVariant.featured_media.alt}`
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        const stickyElement = document.querySelector('.btn-sticky-add-to-cart');
        if (stickyElement) {
          stickyElement.innerHTML = html.querySelector('.btn-sticky-add-to-cart').innerHTML;
          let priceNeedUpdateSticky = document.getElementById("selected-price");
          if(priceNeedUpdateSticky){
            priceNeedUpdateSticky.innerHTML = Shopify.formatMoney(this.currentVariant.price)
          }
        }
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.changeColorVariant();
    this.handleVariant()
  }
  handleVariant() {
    if(!this.querySelector(".js.product-form__input.option-type-color input:checked")){
      return
    }
    const selectedVariant = document.querySelectorAll(".js.product-form__input.option-type-color input:checked")
    const variant = this.querySelectorAll(".js.product-form__input.option-type-color input")
    console.log('variant 1111111',variant);
    
    if(variant.length < 2){
      return
    }
    const thumbnailContainer = document.querySelector(".thumbnail-slider.rocket-product-media.slider-mobile-gutter")
    const slideMb = document.querySelectorAll('.product__media-item.grid__item')
    if(thumbnailContainer){
      thumbnailContainer.querySelectorAll('[data-target-alt]').forEach((element) => {
        const targetAlt = element.getAttribute('data-target-alt')?.split("_")[1];

        if (targetAlt.toLowerCase() !== selectedVariant[0]?.defaultValue.toLowerCase()) {
          element.style.display = 'none';
        } else {
          element.style.display = 'block';
        }
      });
    }
    if(slideMb){
      slideMb.forEach((element) => {
        const mediaAlt = element.getAttribute('data-media-alt')?.split("_")[1];
        if (mediaAlt.toLowerCase() !== selectedVariant[0]?.defaultValue.toLowerCase()) {
          element.style.display = 'none';
        } else {
          element.style.display = 'block';
        }
      });
    }
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
  changeColorVariant() {
    const colorInputs = this.querySelectorAll('.option-type-color input');
    colorInputs.forEach((colorInput) => {
      colorInput.addEventListener('change', () => {
        const colorValue = colorInput.value;
        const colorLabel = colorInput.closest('.option-type-color').querySelector('.option-variant-value');
        colorLabel.innerHTML = colorValue;
      });
      if(colorInput.checked){
        const colorValue = colorInput.value;
        const colorLabel = colorInput.closest('.option-type-color').querySelector('.option-variant-value');
        colorLabel.innerHTML = colorValue;
      }
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class swatchColorProduct extends HTMLElement {
  constructor() {
    super();
    this.itemsColor = this.querySelectorAll('.color-swatch');
    this.parentCard = this.closest('card-product');
  }

  connectedCallback() {
    this.triggleSwatch();
    this.triggleSwatchMb();
    this.innitSlide();
  }
  triggleSwatch() {
    this.itemsColor.forEach((itemsColor) => {
      itemsColor.addEventListener('click', (event) => {
        event.preventDefault();
        const itemsId = itemsColor.getAttribute('data-product-swatch-color-id');
        this.itemsColor.forEach((itemsColors) => {
          itemsColors.parentNode.classList.remove('active');
        });
        itemsColor.parentNode.classList.add('active');

        const itemSwatchElements = this.parentCard.querySelectorAll('[data-product-swatch-id]');
        itemSwatchElements.forEach((itemSwatchElement) => {
          const itemSwatchElementId = itemSwatchElement.getAttribute('data-product-swatch-id');
          if (itemsId === itemSwatchElementId) {
            itemSwatchElement.classList.remove('hidden');
          } else {
            itemSwatchElement.classList.add('hidden');
          }
        });
      });
    });
  }

  triggleSwatchMb() {
    const triggleQuickMbs = document.querySelectorAll('.triggle-quick-add-mobile');

    triggleQuickMbs.forEach(triggleQuickMb => {
      const hoverContainer = triggleQuickMb.parentNode.querySelector('.card__hover__container');
      const hoverContainerItems = hoverContainer?.querySelectorAll('.product-form .product-form__submit');
      const originalParent = hoverContainer.parentNode;
      triggleQuickMb.addEventListener('click', (event) => {
        event.stopPropagation();
        if(originalParent.classList.contains('one-size')) {
          originalParent.querySelector('button.quick-add__submit').click();
        }else {
          hoverContainer.classList.add('active-quick-mb');
          hoverContainer.classList.add('active-quick-mb');
          document.body.classList.add("overflow-hidden-mobile");
          document.body.appendChild(hoverContainer);

          function handleClickOutside(event) {
            if (!hoverContainer.contains(event.target)) {
              if(hoverContainer.classList.contains('active-quick-mb')) {
                hoverContainer.classList.remove('active-quick-mb');
                document.body.classList.remove("overflow-hidden-mobile");
                document.removeEventListener('click', handleClickOutside)
                originalParent.appendChild(hoverContainer);
              }
            }
          }
          document.addEventListener('click', handleClickOutside);


        }
      });

      hoverContainerItems.forEach(hoverContainerItem => {
        hoverContainerItem.addEventListener('click', () => {
          hoverContainer.classList.remove('active-quick-mb');
          document.body.classList.remove("overflow-hidden-mobile");
          originalParent.appendChild(hoverContainer);
        });
      });
    });
  }

  innitSlide() {
    new Swiper(this.querySelector('.product-card-swatch'), {
      slidesPerView: 'auto',
      spaceBetween: 12,
      breakpoints: {
        768: {
          spaceBetween: 6
        }
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}

customElements.define('swatch-color-product', swatchColorProduct);
class swatchColorVariant extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlide();
    this.checkOptionActive();
    this.triggleSwatchMb();
    this.triggerActiveColor();
  }

   triggerActiveColor() {
    let swatchActive = this.querySelector('.color-swatch-active');
    if(swatchActive) {
      swatchActive.click();
    }
  }
  
  initSlide() {
    new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 12,
      breakpoints: {
        768: {
          spaceBetween: 6
        }
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
  checkOptionActive() {
    const swatchColorItems = this.querySelectorAll('.swatches .color-swatch');
    const swatchColorSlideitems = this.querySelectorAll('.swatches .swiper-slide ');
    swatchColorItems.forEach(swatchColorItem => {
      swatchColorItem.addEventListener('click', (event) => {
        event.preventDefault();
        const swatchColorHandle = swatchColorItem.getAttribute('data-variant-color-handle');
        swatchColorSlideitems.forEach((swatchColorSlideitem) => {
          swatchColorSlideitem.classList.remove('active');
        });
        swatchColorItem.parentNode.classList.add('active');

        const itemSwatchElements = swatchColorItem.closest('card-product.rocket-card-container').querySelectorAll('.product-form__input .product-form');
        itemSwatchElements.forEach((itemSwatchElement) => {
          const itemSwatchElementHandle = itemSwatchElement.getAttribute('data-variant-handle-color');
          const closestSwiperSlide = itemSwatchElement.closest('.swiper-slide');
          if (swatchColorHandle === itemSwatchElementHandle) {
            itemSwatchElement.classList.remove('hidden');
            closestSwiperSlide?.classList.remove('hidden');

          } else {
            itemSwatchElement.classList.add('hidden');
            closestSwiperSlide?.classList.add('hidden');
          }
        });

          const swatchColorSrc = swatchColorItem.getAttribute('data-color-options-img');
          const swatchColorImg = swatchColorItem.closest('card-product.rocket-card-container').querySelector('.card__media');
    
          if (swatchColorSrc && swatchColorImg) {
            const firstImg = swatchColorImg.querySelector('img:first-child');
            if (firstImg) {
              firstImg.src = swatchColorSrc;
              firstImg.srcset = swatchColorSrc;
              firstImg.alt = 'Swatch Color';
            }
          }
          const dataVariantColorId = swatchColorItem.getAttribute('data-variant-color-id');
          const linkInfomation = this.closest('card-product').querySelector('.card__information__title a.full-unstyled-link');
          const url = new URL(linkInfomation.href, window.location.origin);
          url.searchParams.set('variant', dataVariantColorId);

          linkInfomation.setAttribute('href', url.pathname + url.search);
    
      });
      const swatchColorActive = swatchColorItem.parentNode.classList.contains('active');
      if(swatchColorActive) {
        const swatchColorHandleActive = swatchColorItem.getAttribute('data-variant-color-handle');
        const itemSwatchElements = swatchColorItem.closest('card-product.rocket-card-container').querySelectorAll('.product-form__input .product-form');
        
        itemSwatchElements.forEach((itemSwatchElement) => {
          const itemSwatchElementHandle = itemSwatchElement.getAttribute('data-variant-handle-color');
          const closestSwiperSlide = itemSwatchElement.closest('.swiper-slide');
          if (swatchColorHandleActive === itemSwatchElementHandle) {
            itemSwatchElement.classList.remove('hidden');            
            closestSwiperSlide?.classList.remove('hidden');            
          } else {
            itemSwatchElement.classList.add('hidden');
            closestSwiperSlide?.classList.add('hidden');
          }
        });
      }
    })
  }
  triggleSwatchMb() {
    const triggleQuickMbs = document.querySelectorAll('.triggle-quick-add-mobile');

    triggleQuickMbs.forEach(triggleQuickMb => {
      const hoverContainer = triggleQuickMb.parentNode.querySelector('.card__hover__container');
      const hoverContainerItems = hoverContainer?.querySelectorAll('.product-form .product-form__submit');
      const originalParent = hoverContainer.parentNode;
      triggleQuickMb.addEventListener('click', (event) => {
        event.stopPropagation();
        if(originalParent.classList.contains('one-size')) {
          originalParent.querySelector('button.quick-add__submit').click();
        }else if (triggleQuickMb.classList.contains('product-only-variant')) {
          const variantTriggleActive = triggleQuickMb.parentNode.querySelectorAll('.card__hover__container .product-form');
          variantTriggleActive.forEach(variantTriggle => {
            if(!variantTriggle.classList.contains('hidden')) {
              variantTriggle.querySelector('button.product-form__submit').click();
            }
          });
        }else {
          const parentTrigger = event.target.closest('.triggle-quick-add-mobile');
          if (parentTrigger) {
              parentTrigger.style.display = "none";
              parentTrigger.classList.add('active');
          }
          hoverContainer.classList.add('active-quick-mb');
          // document.body.classList.add("overflow-hidden-mobile");
          // document.body.appendChild(hoverContainer);

          function handleClickOutside(event) {
            if (!hoverContainer.contains(event.target)) {
              if (parentTrigger) {
                parentTrigger.style.display = "block";
                parentTrigger.classList.remove('active');
              }
              if(hoverContainer.classList.contains('active-quick-mb')) {
                hoverContainer.classList.remove('active-quick-mb');
                // document.body.classList.remove("overflow-hidden-mobile");
                document.removeEventListener('click', handleClickOutside)
                originalParent.appendChild(hoverContainer);
              }
            }
          }
          document.addEventListener('click', handleClickOutside);
        }
      });

      hoverContainerItems.forEach(hoverContainerItem => {
        hoverContainerItem.addEventListener('click', () => {
          hoverContainer.classList.remove('active-quick-mb');
          document.body.classList.remove("overflow-hidden-mobile");
          originalParent.appendChild(hoverContainer);
        });
      });
    });
  }
}

customElements.define('swatch-color-variant', swatchColorVariant);

class popupFormOutStock extends HTMLElement {
  constructor() {
    super();
    this.sizeOutStocks = document.querySelectorAll('.product-form .product-form__submit.disabled');
    this.sizeOutStocks1 = document.querySelectorAll('.quick-add__submit[disabled]');
    this.popupContainer = this.querySelector('.popup-size-out-stock__container');
    this.closePopup = this.querySelector('.popup-size-out-stock__close');
    this.productName = this.querySelector('#product-out-stock-name');
    this.productVaritant = this.querySelector('#product-out-stock-size-selected');
    this.popupProductOutStock();
  }

  popupProductOutStock() {
    this.sizeOutStocks.forEach(sizeoutstock => {
      sizeoutstock.addEventListener('click', (event) => {   
        event.stopPropagation();
        const valueProduct = sizeoutstock.getAttribute('data-value-product');
        const valueVariant = sizeoutstock.getAttribute('data-value-variant');
        document.body.classList.add("overflow-hidden");
        this.classList.remove('hidden');
        this.productName.value = valueProduct;
        this.productVaritant.value = valueVariant;
      });
    });
    this.sizeOutStocks1.forEach(sizeoutstock => {
      sizeoutstock.disabled = false;
      sizeoutstock.addEventListener('click', (event) => {
        event.stopPropagation();
        const valueProduct = sizeoutstock.getAttribute('data-value-product');
        const valueVariant = sizeoutstock.getAttribute('data-value-variant');
        document.body.classList.add("overflow-hidden");
        this.classList.remove('hidden');
        this.productName.value = valueProduct;
        this.productVaritant.value = valueVariant;
      });
    })

    this.closePopup.addEventListener('click', () => {
      document.body.classList.remove("overflow-hidden");
      this.classList.add('hidden');
    });
    document.addEventListener('click', (event) => {
      if (!this.popupContainer.contains(event.target)) {
        document.body.classList.remove("overflow-hidden");
        this.classList.add('hidden');
      }
    });
  }
}

customElements.define('popup-size-out-stock', popupFormOutStock);

class RocketSTLAddAll extends HTMLElement {
  constructor() {
    super()
    this.sectionId = this.dataset.sectionId
    this.sectionSTLContainer = document.querySelector(`.shop-the-look__container[data-section-id="${this.sectionId}"]`)
    this.products = this.sectionSTLContainer.querySelectorAll('.shop-the-look__products.hide-mobile .rocket-product-card-stl')
    this.btnSubmit = this.querySelector('.shop-the-look__container-left__bottom--right__btn-quick-add-all')
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")
    this.drawerLoading = this.cart.querySelector('.drawer-loading')
  }

  connectedCallback() {
    if(this.btnSubmit) {
      this.btnSubmit.addEventListener('click', async (e) => {
        e.preventDefault()
        const items = Array.from(this.products).map(product => {
          if(product.getAttribute('data-available') === 'true') {
            return {
              id: product.getAttribute('data-variant-id'),
              quantity: 1
            }
          }
        })

        if (items.length > 0) {
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            })
            if (response.ok) {
              this.drawerLoading.classList.remove('hidden')
              const cartResponse = await fetch('/cart.js')
              const cartData = await cartResponse.json()

              // Update cart drawer content
              this.updateCartDrawerUI(cartData)

              // Open cart drawer
              document.querySelector('cart-drawer')?.open()
            } else {
              console.error('Add products faild')
            }
          } catch (error) {
            console.error('error: ', error)
          }
        }
      })
    }
  }

  updateCartDrawerUI() {
    fetch(`${routes.cart_url}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html")
      const newCartDrawerInner = html.querySelector('cart-drawer')?.innerHTML
      
      if (newCartDrawerInner) {
        document.querySelector('cart-drawer').innerHTML = newCartDrawerInner
        document.querySelector('cart-drawer').classList.remove('is-empty')
        document.querySelector('.cart-count-bubble').innerHTML = html.querySelector('.cart-count-bubble').innerHTML

        this.drawerLoading.classList.add('hidden')
      }
    })
    .catch(error => console.error('Error update cart drawer: ', error));
  }
}

customElements.define('rocket-stl-add-all', RocketSTLAddAll);

class CardQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.initSlider()
  }

  initSlider() {
    if(this.querySelector('.swiper')) {
      new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 20,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        centerInsufficientSlides: true
      })
    }
  }
}
customElements.define("card-quick-add", CardQuickAdd);

class RocketShopTheLookCS extends HTMLElement {
  constructor() {
    super()
    this.buttons = this.querySelectorAll(".shop-the-look__dot[data-ref-product]")
    this.products = this.querySelectorAll(".rocket-product-card-stl[data-ref-product]")
    this.init()
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener("click", () => {
        const ref = button.getAttribute("data-ref-product")
        const refIndex = button.getAttribute("data-index")
        this.toggleTab(ref, button)

        if(window.innerWidth < 768) {
          this.swiperElement = this.querySelector(".shop-the-look__products .swiper")
          this.swiperInstance = this.swiperElement ? this.swiperElement.swiper : null
          this.swiperInstance.slideTo(parseInt(refIndex))
        }
      })
    })
  }

  toggleTab(ref, button) {
    const isActive = button.classList.contains("active");
    this.buttons.forEach(btn => btn.classList.remove("active"));
    this.products.forEach(product => product.classList.remove("active"))

    if (!isActive) {
      button.classList.add("active");
      this.products.forEach(product => {
        if (product.getAttribute("data-ref-product") === ref) {
          product.classList.add("active")
        }
      })
    }
  }
}

customElements.define("rocket-shop-the-look-cs", RocketShopTheLookCS);